import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ImportListItemResponse, MetaPagination } from '../../../api';
import { BaseDataManagementState } from '../reducers/base-data-management.reducer';

const getDataManagementState = createFeatureSelector('dataManagement');

export const getDataManagement = createSelector(getDataManagementState, (state: any): BaseDataManagementState => state);

export const getImportHistory = createSelector(
  getDataManagement,
  (state: BaseDataManagementState): BaseDataManagementState['importHistory'] => state.importHistory
);

export const getImportHistoryData = createSelector(
  getImportHistory,
  (importHistory): ImportListItemResponse[] => importHistory.data
);

export const getImportHistoryPagination = createSelector(
  getImportHistory,
  (importHistory): MetaPagination['page'] | undefined => importHistory.pagination
);
